import './Header.css'
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';

import { faChalkboardTeacher, faSignInAlt, faHome, faInbox, faListOl, faSignOutAlt, faUser, faBars, faPlusCircle, faFileInvoiceDollar, faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getUserDataAction } from '../../../actions/authActions';
import { removeJwtToken } from '../../../helpers/authHelper';
import routes from '../../../constants/routes';
import es from '../../../lang/es';


const Header = () => {
    //Inicializo el dispatch
    const dispatch = useDispatch();
    const history = useNavigate();
    //Traigo del store
    const user = useSelector(state => state.auth.user);
    //State local
    const [ loading, setLoading ] = useState(false);
    //Verifico si hay datos al inicio
    useEffect(() => {
        //Si no hay datos, debo buscarlos
        if(!user){
            loadData();
        }
    }, []);
    //Cargo datos
    const loadData = () => {
        //Llamo al dispatch
        dispatch( getUserDataAction() );
    }
    //Manejo el logout
    const handleLogout = () => {
        setLoading(true);
        removeJwtToken();
        //Redirecciono
        window.location = `${process.env.REACT_APP_LOGIN_URL}/logout`;
    }
    //Manejo la redirección
    const handleRedirectHome = e => {
        e.preventDefault();
        //Redirecciono
        history.push(routes.HOME);
    }
    //Render
    return (
        <Navbar expand="md" variant="light" bg="light" sticky="top" className="shadow mb-3">
            <Navbar.Brand href={ process.env.REACT_APP_LOGIN_URL }>
                <img
                    src="/img/logos/logo-72.png"
                    width="30"
                    height="30"
                    className="d-inline-block align-top"
                    alt={ process.env.REACT_APP_NAME }
                />
                <span className="ml-2">
                    <b className="h5">{ process.env.REACT_APP_NAME_ALT }</b>
                </span>
            </Navbar.Brand>
            <Navbar.Toggle  aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    <Nav.Link onClick={ handleRedirectHome }>
                            <FontAwesomeIcon icon={faHome} />
                            <span className="ml-1 d-md-none">Inicio</span>
                    </Nav.Link>
                    <NavDropdown title={<><FontAwesomeIcon icon={faBars} /> Aplicaciones</>} id="aplications">
                        <NavDropdown.Item href={ process.env.REACT_APP_QA_PS }>
                            <FontAwesomeIcon icon={faListOl} />
                            <span className="ml-1">Protocolo Sentencias</span>
                        </NavDropdown.Item>
                        <NavDropdown.Item href={ process.env.REACT_APP_QA_EJ }>
                            <FontAwesomeIcon icon={faInbox} />
                            <span className="ml-1">Estrado Judicial</span>
                        </NavDropdown.Item>
                        <NavDropdown.Item href={ process.env.REACT_APP_QA_TN }>
                            <FontAwesomeIcon icon={faChalkboardTeacher} />
                            <span className="ml-1">Instructivos y Formularios</span>
                        </NavDropdown.Item>
                    </NavDropdown>

                    <Button variant="light" href={ process.env.REACT_APP_URL_CAJA } target="_blank" rel="noopener noreferrer" className="text-left text-md-center">
                        <FontAwesomeIcon icon={ faList } /> { es.ACTIONS.LEY_6059 }
                    </Button>

                    {
                        user ? (
                            <>
                            <LinkContainer to={routes.PAYMENT_CREATE}>
                                <Button variant="light" className="text-left text-md-center">
                                    <FontAwesomeIcon icon={ faPlusCircle } /> { es.PAYMENTS.CREATE }
                                </Button>
                            </LinkContainer>

                            <LinkContainer to={routes.PAYMENT_CHECKOUT}>
                                <Button variant="light" className="text-left text-md-center">
                                    <FontAwesomeIcon icon={ faFileInvoiceDollar } /> { es.PAYMENTS.CHECKOUT }
                                </Button>
                            </LinkContainer>
                            </>
                        ) : null
                    }
                </Nav>
            </Navbar.Collapse>
            <Navbar.Collapse className="justify-content-end">
            <Nav>
                {
                    user ? (
                        <NavDropdown title={<><FontAwesomeIcon icon={faUser} /> <span className="ml-1">{user ? `${user.lastname}, ${user.name}` : '-'}</span></>} id="profileMenuId" alignRight>
                            <NavDropdown.Item data-cy="logout-link" onClick={handleLogout} disabled={loading}>
                                <FontAwesomeIcon icon={faSignOutAlt} />
                                <span className="ml-1">{ es.LOGOUT }</span>
                            </NavDropdown.Item>
                        </NavDropdown>
                    ) : (
                        <Nav.Item className="mr-0">
                            <a href={ process.env.REACT_APP_LOGIN_URL } className="btn btn-success text-white">
                                <FontAwesomeIcon icon={ faSignInAlt } /> { es.LOGIN }
                            </a>
                        </Nav.Item>
                    )
                }
            </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default Header;